/* eslint-disable */
import React, { Component } from 'react'


import Svg,{
  Circle,
  Ellipse,
  G,
  LinearGradient,
  RadialGradient,
  Line,
  Path,
  Polygon,
  Polyline,
  Rect,
  Symbol,
  TSpan,
  Use,
  Defs,
  Stop,
  Text
} from 'react-native-svg';

export const SvgLocationEditPostActive = ({size}) => {
    return (  <Svg  width={size} height={size} viewBox="0 0 50 46">
    <G id="Bar-with-caption-box" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-651.000000, -77.000000)" strokeLinecap="round" strokeLinejoin="round">
    <G id="Group-4" transform="translate(653.000000, 79.000000)" stroke="#66CCCC" strokeWidth="3">
        <Polygon id="Shape" points="0 8.4 0 42 14.6363636 33.6 31.3636364 42 46 33.6 46 0 31.3636364 8.4 14.6363636 0"></Polygon>
        <Path d="M15,0 L15,33" id="Shape"></Path>
        <Path d="M32,8 L32,41" id="Shape"></Path>
    </G>
</G>
</Svg>)
}

